export default "__VITE_ASSET__BXOTC5IP__"